<section class="login-page">
	<div class="login-shell">
		<div class="login-card">
			<form class="login-form" [formGroup]="loginFormDytron" (ngSubmit)="login()">
				<div class="form-heading">
					<span>Acceso</span>
					<h1>Ingresar</h1>
					<p>Entra a tu cuenta para continuar con tus postulaciones.</p>
				</div>

				<div class="form-group">
					<label for="login-email">Correo electr&oacute;nico</label>
					<div class="input-wrap">
						<i class="fa fa-envelope-o" aria-hidden="true"></i>
						<input id="login-email" type="email" class="form-control form-control-lg" formControlName="usuario" name="user" required>
					</div>
				</div>

				<div class="form-group">
					<label for="login-password">Contrase&ntilde;a</label>
					<div class="input-wrap">
						<i class="fa fa-lock" aria-hidden="true"></i>
						<input id="login-password" type="password" class="form-control form-control-lg" formControlName="password" name="password" required>
					</div>
				</div>

				<button type="submit" class="login-submit">Acceder</button>

				<div class="login-links">
					<a routerLink="/reset-password">Recuperar contrase&ntilde;a</a>
					<a routerLink="/registro">Crear cuenta</a>
				</div>

				<a class="back-link" routerLink="/start-window">
					<i class="fa fa-arrow-left" aria-hidden="true"></i>
					Regresar
				</a>
			</form>
		</div>

		<div class="login-visual">
			<div class="login-visual-content">
				<span>Pr&aacute;cticas Ejemplares Ecuador</span>
				<h2>Conecta con experiencias que transforman la gesti&oacute;n p&uacute;blica.</h2>
			</div>
		</div>
	</div>
</section>
